<template>
  <div id="app">
    <Tabbar v-if="!$route.meta.showNav"></Tabbar>
    <router-view></router-view>
  </div>
</template>

<script>
import Tabbar from "./components/Tabbar.vue";
import storage from "./utils/storage";
import { getUserInfo } from "./api/api";
// import Vconsole from "vconsole";
export default {
  name: "App",
  components: {
    Tabbar,
  },
  data() {
    return {};
  },
  created() {
    this.$watch(() => {
      if (
        this.$route.name != null && this.$route.name != 'login' && this.$route.name != 'register' && this.$route.name != 'passwordFind' && this.$route.name != 'userDetail' && this.$route.name != 'qyLogin' && this.$route.name != 'guide'
      ) {
        this.getUserInfo();
      }
    });
  },
  mounted() {
    // new Vconsole();
  },
  methods: {
    getUserInfo() {
      getUserInfo({ openid: this.$store.state.OPENID }).then((res) => {
        if (Object.keys(res).length > 0) {
          this.$store.commit("updateUserInfo", res);
        } else {
          // this.$store.commit("updateUserInfo", '');
          // this.$store.commit("updateOpenid", '');
          storage.removeAll()
          // storage.remove('OPENID')
          // storage.remove('USERINFO')
        }
      });
    },
  },
};
</script>

